import {APIErrorEnum} from "../../../Objects/enums/APIErrorEnum";

export const courseTypes = {
	'punctual': 'Cours ponctuel',
	'urgent': 'Cours en urgence',
} as const

export type CourseType = keyof typeof courseTypes

export const errorMessages: { [key in APIErrorEnum]?: string } = {
	[APIErrorEnum.PUNCTUAL_COURSE_RANGE_NOT_CORRESPONDING]: "La durée du cours est supérieure à la plage horaire définie.",
	[APIErrorEnum.PUNCTUAL_COURSE_CLIENT_MUST_HAVE_AT_LEAST_ONE_ADDRESS]: "Vous devez définir au moins une adresse dans votre compte.",
	[APIErrorEnum.PUNCTUAL_COURSE_PENDING_RESERVATIONS_LIMIT_REACHED]: "Vous avez déjà trop de demandes de cours en attente.",
	[APIErrorEnum.PUNCTUAL_COURSE_DURATION_LIMIT_MAX]: "La durée du cours ne peut pas dépasser les 12 heures.",
	[APIErrorEnum.PUNCTUAL_COURSE_DURATION_LIMIT_MIN]: "La durée du cours ne peut pas être inférieure à 1 heure.",
	[APIErrorEnum.PUNCTUAL_COURSE_IS_NOT_COURSE_IN_THE_HOUR]: "Il ne s'agit pas d'un cours dans l'heure.",
	[APIErrorEnum.PUNCTUAL_COURSE_IS_COURSE_IN_THE_HOUR]: "Il s'agit d'un cours dans l'heure.",
	[APIErrorEnum.PUNCTUAL_COURSE_DIRECT_COURSE_NOT_AUTHORIZED]: "Vous n'êtes pas autorisé à demander un cours directement à ce Teach'r.",
	[APIErrorEnum.CHILD_CANNOT_HAVE_MORE_THAN_TEN]: "Vous ne pouvez pas avoir plus de 10 enfants.",
} as const

export type ErrorMessages = keyof typeof errorMessages